export const KNOWLEDGE_BASE_REQUEST = "KNOWLEDGE_BASE_REQUEST";
export const KNOWLEDGE_BASE_RECEIVE = "KNOWLEDGE_BASE_RECEIVE";

export const KNOWLEDGE_SEARCH_VALUES = "KNOWLEDGE_SEARCH_VALUES";
